import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericLookupDropdownSelectorComponent } from './components/generic-lookup-dropdown-selector/generic-lookup-dropdown-selector.component';
import { GenericLookupRadioSelectorComponent } from './components/generic-lookup-radio-selector/generic-lookup-radio-selector.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';

export { GenericLookupDropdownSelectorComponent } from './components/generic-lookup-dropdown-selector/generic-lookup-dropdown-selector.component';
export { GenericLookupRadioSelectorComponent } from './components/generic-lookup-radio-selector/generic-lookup-radio-selector.component';

@NgModule({
  declarations: [GenericLookupDropdownSelectorComponent, GenericLookupRadioSelectorComponent],
  imports: [SharedModule, ReactiveFormsModule, FormsModule, CommonModule, NgSelectModule],
  exports: [GenericLookupDropdownSelectorComponent, GenericLookupRadioSelectorComponent],
})
export class GenericLookupSelectorModule {}
